// extracted by mini-css-extract-plugin
export default {"btn_zamowienia_menu_row_red":"SkasujBTN_btn_zamowienia_menu_row_red__4bMUi"};